export const GET_AGENCIES_REQUEST = 'GET_AGENCIES_REQUEST';
export const GET_AGENCIES_SUCCESS = 'GET_AGENCIES_SUCCESS';
export const GET_AGENCIES_FAILURE = 'GET_AGENCIES_FAILURE';

export const SET_AGENCIES = "SET_AGENCIES";
export const SET_AGENCY = "SET_AGENCY";

export const SUBMIT_AGENCY_REQUEST = 'SUBMIT_AGENCY_REQUEST';
export const SUBMIT_AGENCY_SUCCESS = 'SUBMIT_AGENCY_SUCCESS';
export const SUBMIT_AGENCY_FAILURE = 'SUBMIT_AGENCY_FAILURE';

export const getAgenciesRequest = (filters = {}) => ({
    type: GET_AGENCIES_REQUEST,
    payload: {
        filters
    }
});

export const getAgenciesSuccess = (agencies, total = 0, companies = [], dealers = []) => ({
    type: GET_AGENCIES_SUCCESS,
    payload: {
        agencies,
        companies,
        dealers,
        total
    }
});

export const getAgenciesFailure = err => ({
    type: GET_AGENCIES_FAILURE,
    error: err
});

export const setAgencies = (agencies = [], total = 0) => ({
    type: SET_AGENCIES,
    payload: {
        agencies,
        total
    }
});

export const setAgency = (agency = {}) => ({
    type: SET_AGENCY,
    payload: {
        agency
    }
});

export const submitAgencyRequest = agency => ({
    type: SUBMIT_AGENCY_REQUEST,
    payload: {
        agency
    }
});

export const submitAgencySuccess = agency => ({
    type: SUBMIT_AGENCY_SUCCESS,
    payload: {
        agency
    }
});

export const submitAgencyFailure = err => ({
    type: SUBMIT_AGENCY_FAILURE,
    error: err
});